export enum Patterns{
    Staggered,
    Aligned,
    Helicoidal,   
}